import { render, staticRenderFns } from "./TebligatMasrafList.vue?vue&type=template&id=1e308660"
import script from "./TebligatMasrafList.vue?vue&type=script&lang=ts"
export * from "./TebligatMasrafList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports